import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Signatory } from '../models/signatory-schema'

interface StoreInterface {
  signatories: Signatory[]
  setSignatories: (data: Signatory[]) => void
}

export const useSignatoriesStore = create<StoreInterface>()(
  persist(
    (set, get) => ({
      signatories: [],
      setSignatories: (data) => {
        set({ signatories: [...data] })
      }
    }),
    {
      name: 'signatories-store'
    }
  )
)
